let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("87629")).then(() => parcelRequire('3ZMu3'));